'use strict'
import $ from 'jquery'
// import { data } from '../test-data/help'

/**
 *
 * @param {function} filter
 */
// const filterBy = (filter) => (filtered, each) => {
//   let [prop, value] = each
//   if (filter(prop)) {
//     filtered[prop] = value
//     return filtered
//   }
//   if (typeof value === 'string') {
//     return filtered
//   }
//   let list = Object.entries(value).reduce(filterBy(filter), {})
//   if (Object.keys(list).length === 0) {
//     return filtered
//   }
//   filtered[prop] = list
//   return filtered
// }

/*
 * レンダリング
 */
// const findOn = (root) => (selector) => root.querySelector(selector)
// const find = findOn(document)
// const listenOn = (elm) => (type, handler) => elm.addEventListener(type, handler)
// const listen = listenOn(document)
// const ulWith = (obj, itemsDo) => `
// <div class="m-help">
// ${Object.entries(obj).map(([prop, value]) => `
//   <div class="m-help__item">${itemsDo(prop, value)}</div>
// `).join('')}
// </div>
// `

// const details = (summary, content, open = false) => `
// <div class="m-help__item${open ? ' is-active"' : ''}">
//   <h2 class="a-helpCatTitle">${summary}</h2>
//   ${content}
// </div>
// `
// const detailsList = (obj, contentDo, open = false) => ulWith(obj, (prop, value) => details(prop, contentDo(value), open))
// const cate1List = (obj) => detailsList(obj, (cate2List) => {
//   return detailsList(cate2List, (terms) => {
//     return ulWith(terms, (term, href) => `<a href="${href.link}">${term}</a>`)
//   })
// })
//
// const linkListWith = (filterWord = '') => {
//   let filtered = data
//   if (filterWord) {
//     filtered = Object.entries(data).reduce(filterBy(prop => new RegExp(filterWord, 'i').test(prop)), {})
//   }
//   return cate1List(filtered)
// }

// もっとみる
const moremoreClick = () => {
  $('.js-guideMoreButton').on('click', '', () => {
    $('.js-faq li:gt(9)').fadeIn(1000)
    $('.js-guideMoreButton').fadeOut(1000).remove()
  })
}

const start = () => {
  // 初期表示は一部のみ
  $('.js-faq li:gt(9)').hide()

  if ($('.js-faq li').length <= 10) {
    $('.js-guideMoreButton').remove()
  }
}

// listen('DOMContentLoaded', () => {
//   listenOn(find('.js-helpSearch'))('keyup', event => {
//     find('.js-root').innerHTML = linkListWith(event.currentTarget.value)
//   })
//   find('.js-root').innerHTML = linkListWith('')
//   // start()
//   // moremoreClick()
// })
// const filterBlock = (word) => $('.js-helpSearch-block')
// const filterData = (word) => $('.js-helpSearch-item').each((index, val) => {
//   if (new RegExp(word, 'i').test(val.textContent) || new RegExp(word, 'i').test($(val).data('sub-content')) || new RegExp(word, 'i').test($(val).closest('.js-helpSearch-block').find('.js-helpSearch-title').text())) {
//     $(val).css('display', 'block')
//     $(val).closest('.js-helpSearch-block').css('display', 'block')
//   } else {
//     $(val).closest('.js-helpSearch-block').css('display', 'none')
//     $(val).css('display', 'none')
//   }
// })

const filterData = (word) => $('.js-helpSearch-item').each((index, val, array) => {
  if (new RegExp(word, 'i').test(val.textContent) || new RegExp(word, 'i').test($(val).data('sub-content')) || new RegExp(word, 'i').test($(val).closest('.js-helpSearch-block').find('.js-helpSearch-title').text())) {
    $(val).css('display', 'block').addClass('is-block')
    // $(val).closest('.js-helpSearch-block').css('display', 'block')
  } else {
    // $(val).closest('.js-helpSearch-block').css('display', 'none')
    $(val).css('display', 'none').removeClass('is-block')
  }

  if (!$(val).next().length) {
    if (!$(val).siblings().hasClass('is-block') && !$(val).hasClass('is-block')) {
      $(val).closest('.js-helpSearch-block').css('display', 'none').removeClass('is-block')
    } else {
      $(val).closest('.js-helpSearch-block').css('display', 'block').addClass('is-block')
    }
    if (!$(val).closest('.js-helpSearch-block').next().length) {
      if (!$(val).closest('.js-helpSearch-block').siblings().hasClass('is-block') && !$(val).closest('.js-helpSearch-block').hasClass('is-block')) {
        $(val).closest('.js-helpSearch-block').parent().css('display', 'none').removeClass('is-block').prev().css('display', 'none').removeClass('is-block')
      } else {
        $(val).closest('.js-helpSearch-block').parent().css('display', 'block').addClass('is-block').prev().css('display', 'block').addClass('is-block')
      }
    }
  }
})

/*
const categoryLists = () => {
  const $category = $('.js-helpSearch-category')
  $category.each((index, val) => {
    let isChildren = []
    $(val).next('ul').children('.js-helpSearch-block').each((index, val) => {
      isChildren.push($(val).hasClass('is-block'))
    })
    let checkDisplay = isChildren.every((val, index) => {
      console.log(val)
      return val === false
    })
    if (checkDisplay) {
      $(val).css('display', 'none')
    } else {
      $(val).css('display', 'block')
    }
  })
}
*/

$(function () {
  start()
  moremoreClick()

  $('.a-helpInput').bind('keyup', (e) => {
    let searchWord = $(e.currentTarget).val()
    filterData(searchWord)
  })
})



// WEBPACK FOOTER //
// ./src/scripts/page/help.js